import { z } from 'zod';
/**
 * An Artifact is an immutable stored media object referenced through an opaque
 * identity. What follows describes it to the browser; the bytes never travel in JSON.
 */
/** What the bytes turned out to be, decided by decoding them. */
export const ArtifactKindSchema = z.enum(['image', 'video', 'audio', 'text', 'archive', 'binary']);
/** Which action put the bytes in the store. */
export const ArtifactSourceKindSchema = z.enum([
    'upload',
    'listingImport',
    'generation',
    'derivation',
    'animatic',
    'captions',
    'render',
    'outcomeEvidence',
    'exportPackage',
]);
export const ArtifactResourceSchema = z.object({
    id: z.string().min(1),
    /** An Artifact never changes, so its version never moves off zero. */
    version: z.literal(0),
    mediaType: z.string().min(1),
    kind: ArtifactKindSchema,
    byteSize: z.number().int().positive(),
    width: z.number().int().positive().nullable(),
    height: z.number().int().positive().nullable(),
    durationMs: z.number().int().nonnegative().nullable(),
    contentHash: z.string().regex(/^[0-9a-f]{64}$/),
    sourceKind: ArtifactSourceKindSchema,
    originName: z.string().nullable(),
    createdAt: z.string(),
});
/** The ceiling on one direct upload, shared so the browser can refuse before sending. */
export const ARTIFACT_UPLOAD_MAX_BYTES = 256 * 1024 * 1024;
/** How long one upload may hold a connection before the store abandons it. */
export const ARTIFACT_UPLOAD_MAX_MILLIS = 10 * 60 * 1000;
export const ARTIFACTS_PATH = '/api/v1/artifacts';
//# sourceMappingURL=artifact.js.map